import { UserRole } from './UserRole'

export class BridgeUser {
    UserId!: number
    UserGuid!: string
    UserName!: string
    Role!: UserRole
    Email!: string
    CompanyId!: number
    CompanyGuid!: string
    CompanyName?: string
    Forename!: string
    Surname!: string
    JobTitle?: string
    Country!: string
    ProfilePictureUrl!: string
    Token?: string
    RefreshToken?: string
    Locale?: string
}
